import { globalViewerState } from "../ViewerLayout/useViewerState";
import { ImageComponent } from "./ImageComponent";

export const MoleculeComponent = (props: globalViewerState) =>
  ImageComponent({ ...props, viewerInteractionSettings: { showNavigation: false, interactiveMode: false } });
